/**
 * @name Hotel Room Booking System
 * @author Md. Samiur Rahman (Mukul)
 * @description Hotel Room Booking and Management System Software ~ Developed By Md. Samiur Rahman (Mukul)
 * @copyright ©2023 ― Md. Samiur Rahman (Mukul). All rights reserved.
 * @version v0.0.1
 *
 */

const antTheme = {
  colorPrimary: '#2563eb',
  colorSuccess: '#45d175',
  colorWarning: '#f59e0b',
  colorError: '#ff0000',
  colorInfo: '#5189f5',
  colorBgBase: '#ffffff',
  borderRadius: 6
};

export default antTheme;
